import React from "react";
import styles from './Hamburger.module.css';
import cv from '../../common/assets/ANDRES_FRANK_RESUME.pdf';
import axios from 'axios';

const Hamburger = () => {
    
    function handleLogoClick(e) {
        const checkbox = document.getElementById('menuBtn');
        if (checkbox.checked) checkbox.checked = false;
        window.location.href = '/#home';
    }

    async function handleAnchorClick(e) {
        const checkbox = document.getElementById('menuBtn');
        if (checkbox.checked) checkbox.checked = false;
        if (e.target.title === "downloadCV") {
            try {
                await axios.post('/downloaded-cv');
            } catch(e) {
                console.log(e);
            }
        }
    }

    return (
        <nav className={styles.nav}>
             <div onClick={e => handleLogoClick(e)} className={styles.logo}>
                <span className={styles.logoSpan}>AF</span>
            </div>
            <input className={styles.menuBtn} type="checkbox" id="menuBtn"/>
            {/* Acá la clave está en el for. Cuando tiene ese atributo, al clickear en el label (no en el 
            checkbox necesariamente) activamos el "checked" . */}
            <label className={styles.menuIcon} htmlFor="menuBtn"><span className={styles.navIcon}></span></label>
            <ul className={styles.menu}>
                <li><a onClick={e => handleAnchorClick(e)} href="/#projects">Projects</a></li>
                <li><a onClick={e => handleAnchorClick(e)} href="/#experience">Experience</a></li>
                <li><a onClick={e => handleAnchorClick(e)} href="/#about">About</a></li>
                <li><a onClick={e => handleAnchorClick(e)} href="/#contact">Contact</a></li>
                <li><a title="downloadCV" onClick={e => handleAnchorClick(e)} href={cv} download="CV_ANDRES_FRANK.pdf">Download CV</a></li>
            </ul>
        </nav>
    )
}

export default Hamburger;